import React from "react";
import QueryGeneratorProvider from "./QueryGeneratorContext";
import QueryTablesProvider from "./QueryTablesDataContext";

const QueryBuilderProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <QueryTablesProvider>
        <QueryGeneratorProvider>
          {children}
        </QueryGeneratorProvider>
      </QueryTablesProvider>
    </>
  );
};

export default QueryBuilderProvider;
